/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Group_CustomInputs */

const cs_draft_group_custom = /** @type {(inputs: Draft_Group_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastní`)
};

const en_draft_group_custom = /** @type {(inputs: Draft_Group_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom`)
};

/**
* | output |
* | --- |
* | "Custom" |
*
* @param {Draft_Group_CustomInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_group_custom = /** @type {((inputs?: Draft_Group_CustomInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Group_CustomInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_group_custom(inputs)
	return cs_draft_group_custom(inputs)
});